// 의도적으로 import 없음(zero-dependency). DateUtils.ts 는 popups/Settings 를 거쳐
// index(store) 까지 모듈 그래프를 끌어오므로, 이 파일에 새 함수를 추가하지 말 것.
//
// "표시용 종료 = 실제 종료 - offsetMs" 관용구를 한 곳으로 모은다.
// 종료(endDate)는 exclusive 라서 "해당 날짜/구간에 걸쳐 있는가" 를 비교할 때는
// offsetMs 만큼 당긴 값을 쓴다. 단, duration 0(startDate === endDate) 인 이벤트는
// 당기면 시작보다 앞서(그리고 자정 시작이면 전날로) 밀려버리므로 오프셋을 적용하지 않는다.

/**
 * 표시상의 종료 시각을 반환한다.
 * duration 0 인 이벤트는 오프셋을 적용하지 않고 endDate 를 그대로 반환한다.
 */
export function displayEndDate(startDate: Date, endDate: Date, offsetMs: number = 1): Date {
  if (startDate.valueOf() === endDate.valueOf()) {
    return new Date(endDate.valueOf())
  }
  return new Date(endDate.valueOf() - offsetMs)
}

/**
 * displayEndDate 의 epoch ms 값. 필터 등 valueOf() 비교에 사용한다.
 */
export function displayEndValue(startDate: Date, endDate: Date, offsetMs: number = 1): number {
  return displayEndDate(startDate, endDate, offsetMs).valueOf()
}

/**
 * 이벤트[startDate, endDate) 가 [rangeStart, rangeEnd] 구간과 겹치는가.
 */
export function overlapsRange(
  startDate: Date,
  endDate: Date,
  rangeStart: Date,
  rangeEnd: Date,
): boolean {
  return (
    startDate.valueOf() < rangeEnd.valueOf() &&
    displayEndValue(startDate, endDate) >= rangeStart.valueOf()
  )
}
